// extracted by mini-css-extract-plugin
export default {"root":"PreviewEditMessage_root__5YQkp","bold":"PreviewEditMessage_bold__4dqCe"};